import React, { useMemo } from "react";
import { useFormikContext, getIn } from "formik";
import classnames from "classnames";
import { ILogoPartProps } from "../../models";
import { getAlignmentClass } from "../../models/utils";
import { IPrefillData } from "../../../../../stores/formsStore";
import css from "../../form.module.scss";

interface IProps extends ILogoPartProps {
}

const Logo: React.FC<IProps> = ({style, alignment}) => {
  const { values } = useFormikContext<IPrefillData>();
  const logoUrl = useMemo<string>(() => getIn(values, "LogoUrl"), [values]);
  if (!logoUrl) {
    return null;
  }

  const classes = classnames(css.formPart, getAlignmentClass(alignment));
  return (
    <div className={classes} style={style}>
      <div>
        <img src={logoUrl} alt="Logo" />
      </div>
    </div>
  );
}

export default Logo;






